import React, { useState, useEffect } from "react";
import FeatureCard from "./FeatureCard";
import { formatDateLong } from "../helper/formatters";
import { getTeacherList } from "../../requests";
import { notifyError } from "../helper/Toaster";
import { deleteAuthToken } from "../../utils/helper";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import "../../_css/Overview.css";
import SearchableDropdown from "../common/SearchableDropdown";
import CustomChart from "../common/CustomChart";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { getOverviewStats } from "../../requests";

const OverviewUI = () => {

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalCount, setTotalCount] = useState(0);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [teacherList, setTeacherList] = useState([]);
  const [stats, setStats] = useState({
    total_students: 0,
    total_answer_sheets: 0,
    total_ai_evaluations: 0,
    total_ai_students: 0,
    subject_wise_comparisons: [],
    top_performing_classes: [],
    most_evaluated_subjects: [],
  });

  const getStats = async () => {
    dispatch(startLoader());
    try {
      const response = await getOverviewStats();
      setStats(response.data);
    } catch (error) {
      if (error?.response?.status == 403) {
        notifyError(
          error?.response?.data?.error || "Session Time out log in again"
        );
        deleteAuthToken();
        navigate("/login");
        return;
      }
      notifyError(error?.response?.data?.error || "Something went wrong");
      console.log(error);
    } finally {
      dispatch(stopLoader());
    }
  }


  const getAllTeachers = async () => {
    dispatch(startLoader());
    try {
      const response = await getTeacherList({page: page, limit: limit});
      setTotalCount(response.data.totalCount);
      setTeacherList(response.data.data);
    } catch (error) {
      if (error?.response?.status == 403) {
        notifyError(
          error?.response?.data?.error || "Your session has expired. Please log in again."
        );
        deleteAuthToken();
        navigate("/login");
        return;
      }
      notifyError(error?.response?.data?.error || "Something went wrong");
      console.log(error);
    } finally {
      dispatch(stopLoader());
    }
  };

  const subjects = [
    "All subjects",
    "Mathematics",
    "English",
    "Science",
    "History",
    "Geography",
    "Physics",
    "Chemistry",
    "Biology",
    "Computer Science",
    "Information Technology",
    "Environmental Science",
    "Political Science",
    "Economics",
    "Business Studies",
    "Accountancy",
    "Sociology",
    "Psychology",
    "Philosophy",
    "Civics",
    "Literature",
    "Grammar",
    "Statistics",
    "Engineering Drawing (Theory)",
    "Design and Technology (Theory)",
    "Astronomy",
    "Geology",
    "Anthropology",
    "Archaeology",
    "Law",
    "Media Studies",
    "Communication Skills (Theory)",
    "Entrepreneurship",
    "Marketing",
    "Tourism and Hospitality (Theory)",
    "Fashion Studies (Theory)",
    "Agriculture (Theory)",
    "Computer Applications",
    "Applied Mathematics",
    "Modern History",
    "World History",
    "Ancient History",
    "Political Theory",
    "International Relations",
    "Public Administration",
    "Linguistics",
    "Environmental Studies",
    "Current Affairs",
    "General Knowledge",
    "Moral Science",
  ];

  const classes = ["All classes", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  useEffect(() => {
    getAllTeachers();
    getStats();
  }, [page]);
  return (
    <div className="tm-main">
      <div className="overview-head">
        <div className="overview-head-left">Overview</div>
      
      </div>
      <div className="overview-card-con di-flex">
        <FeatureCard title="AI Evaluations Completed" desc={stats.total_ai_evaluations} color="#F0FAFF" />
        <FeatureCard title="Student Reports Generated " desc={stats.total_ai_students} color="#ECFDF5" />
        <FeatureCard
          title="Answer Sheets Submitted"
          desc={stats.total_answer_sheets}
          color="#FEF2F2"
        />
        <FeatureCard title="Total Students" desc={stats.total_students} color="#FEFCE8" />
      </div>
      <div className="overview-graph-con">
        <div className="class-graph" style={{width: "26%"}}>
          {" "}
          <div>Most evaluated subjects</div>
          <CustomChart
            type="pie"
            xData={[
              ...stats.most_evaluated_subjects.map((e) => e.subject),
            ]}
            yData={stats.most_evaluated_subjects.map((e) => e.total)}
            color="#01A7DE"
            horizontal={false}
            showPlaceholder={false}
            label = 'Total'
          />{" "}
        </div>
        <div className="class-graph" style={{width: "45%"}}>
          {" "}
          <div>Top performing classes</div>
          <CustomChart
            type="bar"
            xData={[
              ...stats.top_performing_classes.map((e) => e.grade),
            ]}
            yData={stats.top_performing_classes.map((e) => e.total || 0)}
            color="#01A7DE"
            horizontal={false}
            showPlaceholder={false}
            label = 'Average Marks'
          />{" "}
        </div>
        <div className="class-graph" style={{width: "26%"}}>
          {" "}
          <div>Submissions by subject</div>
          <CustomChart
            type="pie"
            xData={[
              ...stats.subject_wise_comparisons.map((e) => e.subject),
            ]}
            yData={stats.subject_wise_comparisons.map((e) => e.total)}
            color="#01A7DE"
            horizontal={false}
            showPlaceholder={false}
            label = 'Total'
          />{" "}
        </div>
       
        
      </div>
     

      <div className="teacher-table" style={{ borderTop: "none" }}>
        <div className="teacher-table-head">
          <div className="teacher-table-head-cell" style={{ width: "20%" }}>
            Teacher Name
          </div>

          <div className="teacher-table-head-cell" style={{ width: "20%" }}>
            Class
          </div>
          <div className="teacher-table-head-cell" style={{ width: "14%" }}>
            Subject
          </div>
          <div className="teacher-table-head-cell" style={{ width: "30%" }}>
            School
          </div>

          <div className="teacher-table-head-cell" style={{ width: "16%" }}>
            Uploaded On
          </div>
        </div>

        {teacherList.length > 0 &&
          teacherList.map((el, i) => (
            <div
              key={i}
              className="teacher-table-row"
              style={{ borderBottom: i == teacherList.length - 1 && "none" }}
            >
              <div className="teacher-table-row-cell" style={{ width: "20%" }}>
                {el.name}
              </div>

              <div className="teacher-table-row-cell" style={{ width: "20%" }}>
                {el.grade || "-"}
              </div>
              <div className="teacher-table-row-cell" style={{ width: "14%" }}>
                {" "}
                {el.subject}
              </div>
              <div className="teacher-table-row-cell" style={{ width: "30%" }}>
                {el.school || "-"}
              </div>

              <div className="teacher-table-row-cell" style={{ width: "16%" }}>
                {formatDateLong(el.created_at)}
              </div>
            </div>
          ))}
      </div>
      <div className="di-flex" style = {{width: '100%'}}>
          <div style={{ color: "#6B7280" }}>
            {" "}
            Showing {((page-1) * limit )+ 1} to {teacherList.length + (page - 1) * limit} out of {totalCount}{" "}
            items{" "}
          </div>
          <div
            className="di-flex"
            style={{ justifyContent: "end", gap: "10px" }}
          >
            <button
              disabled={page == 1}
              className="my-btn"
              style={{
                backgroundColor: "#E0F5FE",
                color: "#01A7DE",
                opacity: page == 1 ? 0.4 : 1,
              }}
              onClick={() => setPage((p) => (p > 1 ? p - 1 : p))}
            >
              Previous
            </button>
            <button
              disabled={teacherList.length + (page - 1) * limit >= totalCount}
              className="my-btn"
              style={{
                backgroundColor: "#E0F5FE",
                color: "#01A7DE",
                opacity:
                  teacherList.length + (page - 1) * limit >= totalCount ? 0.4 : 1,
              }}
              onClick={() => setPage((p) => (teacherList.length ? p + 1 : p))}
            >
              Next
            </button>
          </div>
        </div>
    </div>
  );
};

export default OverviewUI;
